import { IQuery } from 'core-ts-types';
export class APSuggestedPlanQuery implements IQuery {
  private _result: {
    plan: string[];
  };

  run(): this {
    this._result = {
      plan: []
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPSuggestedPlanQuery', APSuggestedPlanQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/queries/suggested_plan_query.ts